module.exports = __webpack_public_path__ + "static/img/旅途愉快_300×300.2f5d0ab7.png";